module.exports = __webpack_public_path__ + "static/img/8bg_9.51f75a4.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/8bg_9.png
// module id = 760
// module chunks = 1